import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'approval-groups',
  children: {
    id: {
      path: ':id',
      level: 1,
    },
    approvalGroupsCategoryId: {
      path: ':category/:id',
      children: {
        rulesConfigurations: {
          path: 'rules-configuration',
          children: {
            new: {
              path: 'new',
            },
            edit: {
              path: ':rules_configuration_id',
            },
          },
        },
        details: {
          path: 'details',
          children: {
            configuration: {
              path: 'configuration',
              children: {
                editGroup: {
                  path: 'edit-group',
                },
              },
            },
            employees: {
              path: 'employees',
              children: {
                add: {
                  path: 'add',
                },
                editGroup: {
                  path: 'edit-group',
                },
              },
            },
          },
        },
      },
    },
  },
} as const satisfies Location
